// initialShopsData.js
import Shop1 from "../assets/Shops/shop-1.png";
import Shop2 from "../assets/Shops/shop-2.png";
import Shop3 from "../assets/Shops/shop-3.png";
import Shop4 from "../assets/Shops/shop-4.png";
import Shop5 from "../assets/Shops/shop-5.png";
import Shop6 from "../assets/Shops/shop-6.png";
import Shop7 from "../assets/Shops/shop-7.png";
import Shop8 from "../assets/Shops/shop-8.png";
import Shop9 from "../assets/Shops/shop-9.png";

import product1 from "../assets/Shops/products1.png";
import product2 from "../assets/Shops/products2.png";
import product3 from "../assets/Shops/products3.png";
import product4 from "../assets/Shops/products4.png";
import product5 from "../assets/Shops/products5.png";
import product6 from "../assets/Shops/products6.png";
import product7 from "../assets/Shops/products7.png";
import product8 from "../assets/Shops/products8.png";
import rahul from "../assets/rahul.png";
import ram from "../assets/ram.png";
import july from "../assets/july.png";
const commonProducts = [
  {
    id: 101,
    title: "Pedigree",
    image: product1,
    price: 450,
    originalPrice: 500,
    discount: 10,
    category: "dog",
    subCategory: "food",
  },
  {
    id: 102,
    title: "Himalaya",
    image: product2,
    price: 1500,
    originalPrice: 1500,
    tag: "Popular",
    category: "dog",
    subCategory: "food",
  },
  {
    id: 103,
    title: "Fidele",
    image: product3,
    price: 1170,
    originalPrice: 1300,
    discount: 10,
    category: "dog",
    subCategory: "food",
  },
  {
    id: 104,
    title: "Superfood",
    image: product4,
    price: 1200,
    originalPrice: 1200,
    tag: "Steal Deal",
    category: "cat",
    subCategory: "food",
  },
  {
    id: 105,
    title: "Shovel Spoon",
    image: product5,
    price: 400,
    originalPrice: 450,
    discount: 10,
    category: "dog",
    subCategory: "accessories",
  },
  {
    id: 106,
    title: "Whisk",
    image: product6,
    price: 1700,
    originalPrice: 1700,
    tag: "Popular",
    category: "cat",
    subCategory: "accessories",
  },
  {
    id: 107,
    title: "Pets Empire",
    image: product7,
    price: 1350,
    originalPrice: 1500,
    discount: 10,
    category: "dog",
    subCategory: "accessories",
  },
  {
    id: 108,
    title: "Travel Bag",
    image: product8,
    price: 1000,
    originalPrice: 1000,
    tag: "Steal Deal",
    category: "cat",
    subCategory: "accessories",
  },
  {
    id: 109,
    title: "Drools",
    image: product1,
    price: 600,
    originalPrice: 700,
    discount: 15,
    category: "dog",
    subCategory: "food",
  },
  {
    id: 110,
    title: "Royal Canin",
    image: product2,
    price: 1800,
    originalPrice: 2000,
    discount: 10,
    category: "cat",
    subCategory: "food",
  },
  {
    id: 111,
    title: "Gnawlers Chew Stick",
    image: product3,
    price: 250,
    originalPrice: 300,
    discount: 17,
    category: "dog",
    subCategory: "accessories",
  },
  {
    id: 112,
    title: "Catnip Delight",
    image: product4,
    price: 350,
    originalPrice: 400,
    discount: 12,
    category: "cat",
    subCategory: "accessories",
  },
  {
    id: 113,
    title: "Canine Protein Mix",
    image: product5,
    price: 1250,
    originalPrice: 1350,
    tag: "Popular",
    category: "dog",
    subCategory: "food",
  },
  {
    id: 114,
    title: "Kitty Kibble",
    image: product6,
    price: 800,
    originalPrice: 950,
    discount: 16,
    category: "cat",
    subCategory: "food",
  },
  {
    id: 115,
    title: "Pet Collar",
    image: product7,
    price: 500,
    originalPrice: 550,
    discount: 9,
    category: "dog",
    subCategory: "accessories",
  },
  {
    id: 116,
    title: "Soft Pet Blanket",
    image: product8,
    price: 950,
    originalPrice: 1000,
    tag: "Steal Deal",
    category: "cat",
    subCategory: "accessories",
  },
];

export const initialShops = [
  {
    id: 1,
    name: "Petcare Shop",
    address: "Chennai",
    name: "Petcare Shop",
    address: "Chennai",
    image: Shop1,
    products: commonProducts.map((p, i) => ({ ...p, id: 1000 + 1 * 100 + i })),
  },
  {
    id: 2,
    name: "Paw Haven",
    address: "Maharashtra",
    image: Shop2,
    products: commonProducts.map((p, i) => ({ ...p, id: 1000 + 2 * 100 + i })),
  },
  {
    id: 3,
    name: "The Vet’s Stop",
    address: "Bengaluru",
    image: Shop3,
    products: commonProducts.map((p, i) => ({ ...p, id: 1000 + 3 * 100 + i })),
  },
  {
    id: 4,
    name: "Petcare Shop",
    address: "Chennai",
    image: Shop4,
    products: commonProducts.map((p, i) => ({ ...p, id: 1000 + 4 * 100 + i })),
  },
  {
    id: 5,
    name: "Paw Haven",
    address: "Maharashtra",
    image: Shop5,
    products: commonProducts.map((p, i) => ({ ...p, id: 1000 + 5 * 100 + i })),
  },
  {
    id: 6,
    name: "The Vet’s Stop",
    address: "Bengaluru",
    image: Shop6,
    products: commonProducts.map((p, i) => ({ ...p, id: 1000 + 6 * 100 + i })),
  },
  {
    id: 7,
    name: "Petcare Shop",
    address: "Chennai",
    image: Shop7,
    products: commonProducts.map((p, i) => ({ ...p, id: 1000 + 7 * 100 + i })),
  },
  {
    id: 8,
    name: "Paw Haven",
    address: "Maharashtra",
    image: Shop8,
    products: commonProducts.map((p, i) => ({ ...p, id: 1000 + 8 * 100 + i })),
  },
  {
    id: 9,
    name: "The Vet’s Stop",
    address: "Bengaluru",
    image: Shop9,
    products: commonProducts.map((p, i) => ({ ...p, id: 1000 + 9 * 100 + i })),
  },
];


const providers = [
  {
    id: 1,
    name: { name: "Thilak", avatar: rahul },
    center: "Grooming Booking",
    available: true,
  },
  {
    id: 2,
    name: { name: "Asha", avatar: july },
    center: "Grooming Booking",
    available: false,
  },
  {
    id: 3,
    name: { name: "Ravi", avatar: ram },
    center: "Grooming Booking",
    available: true,
  },
  {
    id: 4,
    name: { name: "Meena", avatar: july },
    center: "Grooming Booking",
    available: false,
  },
  {
    id: 5,
    name: { name: "July", avatar: rahul },
    center: "Grooming Booking",
    available: true,
  },
  {
    id: 6,
    name: { name: "Vikram", avatar: ram },
    center: "Grooming Booking",
    available: false,
  },
];
